export type ShareChannel = 'copy_link' | 'whatsapp' | 'facebook' | 'linkedin'

const UTM_MEDIUM = 'referral'
const UTM_CAMPAIGN = 'compartilhamento_curso'

/**
 * Appends UTM parameters to a course URL so GA4 can identify traffic coming
 * from the course-share feature as referral, while preserving the original
 * URL (course identification stays in the path) and any existing query
 * params.
 */
export function buildShareUrl(url: string, channel: ShareChannel): string {
  if (!url) {
    return url
  }

  try {
    const shareUrl = new URL(url)
    shareUrl.searchParams.set('utm_source', channel)
    shareUrl.searchParams.set('utm_medium', UTM_MEDIUM)
    shareUrl.searchParams.set('utm_campaign', UTM_CAMPAIGN)
    return shareUrl.toString()
  } catch {
    return url
  }
}
